import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import {
  handleError,
  ValidateInputs,
} from "../../utils/helper";
import { useAuth } from "../../context/AuthContext";
import { usePublicClient, useWriteContract } from "wagmi";
import { ICO_ABI } from "../../Contract/ICO_ABI";
import { ICO_CONTRACT_ADDRESS } from "../../utils/constant";
import { config } from "../../config";
import { readContract } from "@wagmi/core";
import Loader from "../Loader/Loader";
import { useAppKitAccount } from "@reown/appkit/react";
import { toast } from "react-toastify";
import { parseUnits } from "viem";

const UpdatePriceModal = ({ show, handleClose, onPriceUpdated }) => {
  const [errors, setErrors] = useState({});
  const { icoValues, fetchIcoValues } = useAuth();
  const initialData = {
    amount: icoValues?.usdtValue,
  };
  const [data, setData] = useState(initialData);
  const { writeContractAsync } = useWriteContract();
  const [loading, setLoading] = useState(false);
  const { isConnected, address } = useAppKitAccount();
  const publicClient = usePublicClient();

  const validate = () => {
    const newErrors = {};

    console.log("data?.amount", data?.amount);

    if (!data?.amount) {
      newErrors.amount = "Amount is required";
    } else if (Number(data?.amount) <= 0) {
      newErrors.amount = "Amount must be greater than 0";
    } else if (!data?.amount || isNaN(Number(data?.amount))) {
      newErrors.amount = "Amount must be a number";
    } else if (String(data?.amount).length > 10) {
      newErrors.amount = "Amount cannot exceed 10 digits";
    }

    console.log("newErrors", newErrors);

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  console.log("errors dek", errors);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name === "amount") {
      // Limit total character length to 10
      if (value.length > 10) {
        return; // Prevent update if exceeds length
      }

      // Limit to 4 decimal places using regex
      const decimalRegex = /^\d*\.?\d{0,4}$/;
      if (!decimalRegex.test(value)) {
        return; // Prevent update if more than 4 decimals
      }

      setData((prev) => ({
        ...prev,
        [name]: value,
      }));

      if (value === "") {
        setErrors((prev) => ({
          ...prev,
          amount: "Amount is required",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          amount: "",
        }));
      }
    }
  };

  console.log("amount", data?.amount);

  const updatePrice = async () => {
    if (!validate()) {
      return;
    }
    try {
      console.log("clicked");
      setLoading(true);
      if (!validate()) {
        return;
      }
      console.log("clicked2");
      console.log("data?.amount", typeof data?.amount, data?.amount);

      const contractData = {
        abi: ICO_ABI,
        address: ICO_CONTRACT_ADDRESS,
        functionName: "updateTokenPrice",
        args: [parseUnits(data?.amount || "0", 8)],
      };

      console.log("data", data);

      await readContract(config, {
        ...contractData,
        account: address,
      });

      const tx = await writeContractAsync(contractData);
      console.log("tx", tx);
      const receipt = await publicClient.waitForTransactionReceipt({
        hash: tx,
      });

      if (receipt?.status === "success") {
        await fetchIcoValues();
        toast.success("Price updated successfully");
        if (onPriceUpdated) {
          onPriceUpdated({ newPrice: data?.amount });
        }
        handleClose();
      }
    } catch (error) {
      console.log("update price error", error);

      const contractError = handleError(error?.cause?.data);
      console.error("Something went wrong:", contractError);
    } finally {
      setLoading(false);
      setErrors({});
    }
  };

  return (
    <>
      {loading && <Loader />}
      <Modal
        show={show}
        onHide={() => {
          handleClose();
          setErrors({});
          setData(initialData);
        }}>
        <Modal.Header closeButton>
          <Modal.Title>{"Update Token Price"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="taskQuestion">
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                name="amount"
                placeholder="Enter amount"
                value={data.amount}
                onChange={handleChange}
                className={`${errors.amount ? "is-invalid" : ""}`}
                required
              />
              {errors.amount && (
                <div className="invalid-feedback">{errors.amount}</div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              handleClose();
              setErrors({});
              setData(initialData);
            }}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updatePrice}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdatePriceModal;
